import {
 
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  Renderer2,
  SecurityContext,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { OCC_USER_ID_CURRENT } from '@spartacus/core';
import { AuthService } from '@spartacus/core';
import {
  Observable,
  Subject,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  take,
} from 'rxjs';
import {
  testRegex,
  REGULAR_PATTERN,
} from '../../../../../core/generic-validator/regular-expressions';
import { ProductSearchType } from '../../../../../core/rma/models/rma-form.models';
import { RmaEntry } from '../../../../../shared/models/rma/rma.model';
import { RmaService } from '../../../../rma/rma-services/rma.service';
import { LaunchDialogService } from '@spartacus/storefront';
import { DS_DIALOG } from '../../../../../core/dialog/dialog.config';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-waygate-rma-product-search',
  standalone: false,
  templateUrl: './waygate-rma-product-search.component.html',
  styleUrl: './waygate-rma-product-search.component.scss',
})
export class WaygateRmaProductSearchComponent implements OnDestroy {
  productSearchType = ProductSearchType;
  @Input()
  searchType = this.productSearchType.PART;

  @Input() selectedPart: any;

  @Output()
  helpSearchOpen = new EventEmitter<boolean>();

  @Output()
  searchProducts = new EventEmitter<any>();

  @Output()
  partSelected = new EventEmitter<any>();



  @Input()
  rmaEntry: RmaEntry;

  @Input() disableSerialSearch = false;

  searchForm: FormGroup;

  public searchResults;
  parts: any;
  openSuggestions: boolean;

  @Output() rmaPartNumber = new EventEmitter<any>();
  @Output() serialNumberChanged = new EventEmitter<string>();

  @ViewChild('partNumberInput', { static: true }) partNumberInput: ElementRef;

  @Output() guestProductConfirmed=new EventEmitter<any>();

  showPartNoInfo: boolean = false;
  showserialNOInfo: boolean = false;

  searchResults$: Observable<any>;
  subject = new Subject();
confirmedProduct:any=null;
  searchingProducts = false;
isGuest=false;
isNotGuest=true;
isLoggedIn:boolean=false;
userType: string;
  serialSearchSubject = new Subject<string>();

  serialSearchResults: any[] = [];
  openSerialSuggestions = false;
  @Output() clearSelectedPart = new EventEmitter<void>();
  // selectedPart: any = null;
  //disableSerialSearch = false;

  searchTypeEnum = [
    { id: '', searchLabel: 'Equals' },
    { id: 1, searchLabel: 'Starts With' },
    { id: 2, searchLabel: 'Contains' },
    { id: 3, searchLabel: 'Ends With' },
  ];
  searialSearchTypeVal = '';
  searchingResults = false;
  productImageContainer: { product: any; };

  constructor(
    private rmaService: RmaService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    public sanitizer: DomSanitizer,
    public launchDialogService:LaunchDialogService,
    private auth:AuthService
   
  ) {
    this.searchForm = this.formBuilder.group({
      partNumber: new FormControl(''),
      serialNumber: new FormControl('',Validators.required),
      filterType: new FormControl(null),
    });
  }

  ngOnInit(): void {
    this.searchForm.patchValue({
      searchTerm: this.rmaEntry?.partNumber || '',
    });

    this.searchResults$ = this.subject.pipe(
      debounceTime(450),
      distinctUntilChanged(),
      map(() => {
        this.autoComplete();
      })
    );

    this.searchResults$.subscribe();
this.searchForm.get('serialNumber')?.valueChanges.subscribe(value=>{
  if(!value?.trim()){
    this.confirmedProduct=null;
  }
})

    if (this.rmaEntry?.partNumber) {
      this.subject.next(this.rmaEntry.partNumber);
      setTimeout(() => {
        this.renderer.selectRootElement('#partNumberInput').focus();
      }, 500);
    }

    this.serialSearchSubject
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((term: string) => {
        if (term.length >= 3) {
          this.autoSearchSerialTrigger(term);
        }
      });
      this.auth.isUserLoggedIn().subscribe((isUserLoggedIn) => {
    this.isLoggedIn = isUserLoggedIn;
    this.userType=isUserLoggedIn?'current' : 'anonymous';
 
    console.log('RMA User Logged In:', this.isLoggedIn);
    console.log('RMA User type:', this.userType);
  });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedPart']?.currentValue) {
      this.selectedPart = changes['selectedPart'].currentValue;
      this.searchForm.patchValue({
        partNumber: this.selectedPart?.code || '',
        serialNumber: this.selectedPart?.serialNumber || '',
      });
      this.partSelected.emit(this.selectedPart);

      this.openSuggestions = false;
      this.disableSerialSearch = true;
    }
  }

  openHelpSearch() {
    this.helpSearchOpen.emit(true);
  }
  
searchSerialNumberproduct(): void {
  const serialControl=this.searchForm.get('serialNumber');
  const serialNumber =
    serialControl?.value?.trim();
 if (!serialNumber) {
  serialControl?.markAsTouched();
  serialControl?.setErrors({required:true});
    return;
  }
  console.log('Guest Serial Number:', serialNumber);
  this.rmaService.guestSearchSerial(serialNumber).subscribe({
    next: (res) => {
      console.log('Guest API Response:', res);
 
        this.launchDialogService.dialogClose.pipe(filter((product:any)=>
          product && typeof product ==='object'),take(1)).subscribe((product:any)=>{
          if(product){
            this.confirmedProduct=product;
            const productImage = this.confirmedProduct?.images?.find(
  (image: any) => image.format === 'product'
);
 
this.productImageContainer = productImage
  ? {
      product: productImage
    }
  : null;
this.guestProductConfirmed.emit({
  serialNumber:serialNumber,
  productDetails:product
});
          }
        })

        const productDetailsDialog=this.launchDialogService.openDialog(
          DS_DIALOG.WAYGATE_RMA_PRODUCT_DETAILS_MODAL,
          undefined,
          undefined,
          {
            serialNumber: serialNumber,
            productDetails: res
          }
        );
        if(productDetailsDialog){
productDetailsDialog.pipe(take(1)).subscribe((dialogRef:any)=>{
  console.log('product details',dialogRef);
});
        }
      },
    error: (error) => {
      console.error('Guest API Error:', error);
    }
  });
}

viewProductDetails(): void {
  if (!this.confirmedProduct) {
    return;
  }
 
  console.log(
    'Opening Product Details:',
    this.confirmedProduct
  );
 
 const dialog=this.launchDialogService.openDialog(
    DS_DIALOG.WAYGATE_RMA_PRODUCT_VIEW_DETAILS_MODAL,
    undefined,
    undefined,
    {
      product: this.confirmedProduct,
    }
  );
  dialog?.pipe(take(1)).subscribe((result)=>{
    console.log('product details dialog closed',result);
  })
}
  autoSearchResults(evt) {
    const value = testRegex(evt.target.value, REGULAR_PATTERN.alphaNumeric);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, value);
    this.searchForm.patchValue({ partNumber: sanitized });

    if (!sanitized || sanitized.length < 1) {
      this.parts = [];
      this.openSuggestions = false;
      return;
    }

    this.subject.next(sanitized);
  }

  autoComplete() {
    const searchTerm = this.searchForm.value.partNumber?.trim();
    if (!searchTerm) return;

    this.searchingProducts = true;
    this.parts = null;
    this.openSuggestions = true;

    this.rmaPartNumber.emit({ searchText: searchTerm, parts: this.parts });

    const searchObj = {
      term: searchTerm,
      filter: 'RETURN',
    };

    this.rmaService.autoComplete(OCC_USER_ID_CURRENT, searchObj).subscribe(
      (res) => {
        this.searchingProducts = false;
        this.parts = res;
        this.rmaPartNumber.emit({ searchText: searchTerm, parts: this.parts });
      },
      () => {
        this.searchingProducts = false;
        this.parts = [];
        this.rmaPartNumber.emit({ searchText: searchTerm, parts: this.parts });
      }
    );
  }

  autoSearchSerial(event: any) {
    // if (this.disableSerialSearch) return;
    if (this.disableSerialSearch) {
      const raw = event.target.value;
      const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, raw);
      this.searchForm.patchValue({ serialNumber: sanitized });
      this.serialNumberChanged.emit(sanitized);
      return;
    }
    const value = testRegex(event.target.value, REGULAR_PATTERN.alphaNumeric);
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, value);
    this.searchForm.patchValue({ serialNumber: sanitized });
    this.serialNumberChanged.emit(sanitized);
    if (!sanitized || sanitized.length < 1) {
      this.serialSearchResults = [];
      this.openSerialSuggestions = false;
      return;
    }

    this.serialSearchSubject.next(sanitized);
  }
openContactDetailsDialog(): void {
  const dialogRef = this.launchDialogService.openDialog(
    DS_DIALOG.WAYGATE_RMA_CONTACT_DETALIS_MODAL,
    undefined,
    undefined
  );
 
  if (dialogRef) {
    dialogRef.pipe(take(1)).subscribe((result) => {
      if (result && result !== 'close') {
        console.log('Submitted contact details:', result);
      }
    });
  }
}
  autoSearchSerialTrigger(term: string) {
    const searchObj = {
      filter: 'RETURN',
      isSerialSearch: true,
      pageNumber: 0,
      pageSize: 250,
      searchType: '',
      srNum: term,
    };

    this.searchingResults = true;
    this.rmaService.partSearch(OCC_USER_ID_CURRENT, searchObj).subscribe(
      (searchResults) => {
        this.searchingResults = false;
        this.serialSearchResults = searchResults as any[];
        this.openSerialSuggestions = true;
      },
      () => {
        this.searchingResults = false;
        this.serialSearchResults = [];
        this.openSerialSuggestions = false;
      }
    );
  }

  selectPart(product) {
    this.selectedPart = product;
    this.disableSerialSearch = true;
    this.partSelected.emit({ ...product, similar: false });
    this.closeSuggestions();
  }

  selectSerial(product: any) {
    this.selectedPart = product;
    this.disableSerialSearch = false;

    this.searchForm.patchValue({
      partNumber: product.code,
      serialNumber: product.serialNumber || '',
    });

    this.partSelected.emit({
      ...product,
      similar: false,
      serialNumber: product.serialNumber,
    });

    this.openSerialSuggestions = false;
  }

  clearPartSelection() {
    this.selectedPart = null;
    this.searchForm.reset();
    this.disableSerialSearch = false;
    this.clearSelectedPart.emit();
  }
  clearSerialNumber(): void {
  this.searchForm.get('serialNumber')?.setValue('');
  this.selectedPart = null;
  this.disableSerialSearch = false;
  this.openSerialSuggestions = false;
  this.confirmedProduct=null;
 
  this.searchForm.get('serialNumber')?.markAsPristine();
  this.searchForm.get('serialNumber')?.markAsUntouched();
 
  this.clearSelectedPart.emit();
}

  closeSuggestions() {
    this.openSuggestions = false;
  }
  ngOnDestroy() {
    this.clearPartSelection();
  }
}

